import { render, staticRenderFns } from "./clause.vue?vue&type=template&id=5816b2ae&"
import script from "./clause.vue?vue&type=script&lang=js&"
export * from "./clause.vue?vue&type=script&lang=js&"
import style0 from "./clause.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5816b2ae')) {
      api.createRecord('5816b2ae', component.options)
    } else {
      api.reload('5816b2ae', component.options)
    }
    module.hot.accept("./clause.vue?vue&type=template&id=5816b2ae&", function () {
      api.rerender('5816b2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/help/clause.vue"
export default component.exports